import {responseToData, transferify, unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {Ordered, Department, Location, ActionResponse, LocationRequest} from 'typings/portaro.be.types';

export default class LocationDataService {
    public static serviceName = 'locationDataService';

    public static readonly ROUTE = 'locations';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getAllByDepartment(department: Department): Promise<Location[]> {
        try {
            return await this.Restangular
                .all(LocationDataService.ROUTE)
                .getList({department: department.id});
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getAll(queryParams: {viewable?: boolean}): Promise<Location[]> {
        try {
            return await this.Restangular
                .all(LocationDataService.ROUTE)
                .getList(queryParams);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async save(locationRequest: LocationRequest | Ordered): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .all(LocationDataService.ROUTE)
                .post(transferify(locationRequest))
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async remove(location: Location): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .one(LocationDataService.ROUTE, location.id)
                .remove();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}
